'use strict';
import { EnableAdobeAnalytics } from '../../utilities/featureFlags';

var $ = require('jquery'),
  _ = require('underscore'),
  mediator = require('../mediator'),
  config = require('../config'),
  Analytics = require('../../components/Analytics/Analytics'),
  utils = require('../utilities'),
  $global = require('../globalElements'),
  Backbone = require('backbone');

const YOUTUBE_PLAYER_STATE_UNSTARTED = -1;

Backbone.$ = $;
/*
function getControlDiv(playerId) {
  var controlDiv = $('#' + playerId).next();
  return controlDiv;
}
*/
function ControlElement(player, elementClass, $parent) {
  this.player = player;
  this.$controlDiv = $parent.find('iframe.player').next();
  this.$domElement = this.$controlDiv.find(elementClass);
}

// play control object
function PlayControl(player, $parent) {
  ControlElement.call(this, player, '.play-button', $parent);

  var self = this;

  this.$domElement.on('click', function() {

    var playerState = {
        unstarted: -1,
        ended: 0,
        playing: 1,
        paused: 2,
        buffering: 3,
        cued: 5
      },
      state = self.player.getPlayerState();
    switch (state) {
      case playerState.paused:
        player.playVideo();
        mediator.trigger(config.events.youtubePlayer.played, self);
        break;
      case playerState.ended:
        player.playVideo();
        break;
      case playerState.playing:
        player.pauseVideo();
        mediator.trigger(config.events.youtubePlayer.paused, self);
        break;
      case playerState.cued:
        player.playVideo();
        break;
    }
  });
}

PlayControl.prototype.updateIcon = function(state) {
  this.$domElement.removeClass('play-button--playing play-button--paused');
  switch (state.data) {
    case -1:
    case 0:
    case 2:
    case 5:
      this.$domElement.addClass('play-button--paused');
      break;
    case 1:
    case 3:
      this.$domElement.addClass('play-button--playing');
      break;
  }
};

// duration object
function DurationDisplay(player, $parent) {
  ControlElement.call(this, player, '.duration', $parent);
  this.pos = this.$domElement.find('.pos');
  this.len = this.$domElement.find('.len');

  var lenTime = utils.toHHMMSS(Math.floor(player.getDuration()).toString());
  this.setLen(lenTime);
}

DurationDisplay.prototype.updatePos = function(time) {
  this.pos.html(time);
};

DurationDisplay.prototype.setLen = function(time) {
  this.len.html(time);
};

function ProgressControl(player, $parent) {
  ControlElement.call(this, player, '.progress-slider', $parent);
  this.$progress = this.$domElement.find('.progress');
  this.mousedown = false;
}

ProgressControl.prototype.setProgress = function(percent) {
  this.$progress.css('width', percent + '%');
};

function VolumeControl(player, $parent) {
  ControlElement.call(this, player, '.volume-control', $parent);

  var self = this;
  this.muted = false;
  this.mousedown = false;

  this.$volumeAmount = this.$domElement.find('.volume-amount');
  this.$volumeSlider = this.$domElement.find('.volume-slider');
  this.$volumeTracks = this.$domElement.find('.volume-tracks');
  this.$volumeButton = this.$domElement.find('.volume-button');
  this.volume = this.$volumeAmount.height();

  this.$domElement.on({
    mouseenter: function() {
      $(this).find('.volume-tracks').addClass('volume-tracks--popout');
    },
    mouseleave: function() {
      $(this).find('.volume-tracks').removeClass('volume-tracks--popout');
    }
  });

  this.$volumeButton.on('click', function() {
    self.muted = !self.muted;
    if (self.muted) {
      self.$volumeAmount.css('height', 0 + '%');
      self.player.setVolume(0);
    } else {
      self.setVol(self.volume);
    }
  });

  this.$volumeTracks.on({
    mousedown: function() {
      self.mousedown = true;
    },
    mouseup: function() {
      self.mousedown = false;
    },
    click: function(e) {

      var height = self.$volumeSlider.height(),
        posY = e.pageY - self.$volumeSlider.offset().top,
        percent = posY / (height / 100);
      percent = 100 - percent;
      self.setVol(percent);
    }
  });

  $global.$document.on({
    mouseup: function() {
      self.mousedown = false;
    },
    mousemove: function(e) {
      if (self.mousedown) {
        e.preventDefault();
        var height = self.$volumeSlider.height(),
          posY = e.pageY - self.$volumeSlider.offset().top,
          percent = posY / (height / 100);
        if (percent && (percent <= 100)) {
          percent = 100 - percent;
          self.setVol(percent);
        }
      }
    }
  });
}

VolumeControl.prototype.setVol = function(percent) {
  this.volume = percent;
  this.$volumeAmount.css('height', percent + '%');
  this.player.setVolume(percent);
};

function ControlDiv(player, $parent) {
  var self = this;
  this.player = player;
  this.playControl = new PlayControl(player, $parent);
  this.duration = new DurationDisplay(player, $parent);
  this.progressControl = new ProgressControl(player, $parent);
  this.volumeControl = new VolumeControl(player, $parent);

  //placed in here because it interacts with multiple children
  this.progressControl.$domElement.on({
    mousedown: function() {
      self.progressControl.mousedown = true;
    },
    mouseup: function() {
      self.progressControl.mousedown = false;
    },
    click: function(e) {

      var width = self.progressControl.$domElement.width(),
        posX = e.pageX - self.progressControl.$domElement.offset().left,
        percent = posX / (width / 100),
        newTime = (player.getDuration() / 100) * percent;

      self.progressControl.$progress.css('width', percent + '%');
      player.seekTo(newTime);
      self.duration.pos.html(utils.toHHMMSS(newTime.toString()));
    }
  });

  $global.$document.on({
    mouseup: function() {
      self.progressControl.mousedown = false;
    },
    mousemove: function(e) {
      if (self.progressControl.mousedown) {
        e.preventDefault();

        var width = self.progressControl.$domElement.width(),
          posX = e.pageX - self.progressControl.$domElement.offset().left,
          percent = posX / (width / 100);

        if (percent && (percent <= 100)) {
          player.setVolume(percent);
          self.progressControl.$progress.css('width', percent + '%');
          var newTime = (player.getDuration() / 100) * percent;
          player.seekTo(newTime);
          self.duration.pos.html(utils.toHHMMSS(newTime.toString()));
        }
      }
    }
  });
}

function PushDataToAdobeLayer(videoViewEvent) {
  let videoView = {
    event: videoViewEvent,
    videoId: document.getElementsByClassName('YouTubeWrapper')[0].getAttribute('data-video-id') || undefined,
    videoName: document.getElementsByClassName('player')[0].title || undefined,
  }
  Analytics.setOnAdobeDataLayer(videoView);
}

ControlDiv.prototype.updateTime = function() {

  var self = this;

  if (!$.inArray(this.player.getPlayerState(), [1, 3])) {
    //get time
    var length = this.player.getDuration() / 100,
      time = this.player.getCurrentTime(),
      percent = time / length;
    //eh...
    
    if (EnableAdobeAnalytics.isEnabled()) {
    this.completionPercentage = percent.toFixed(2);

      if (parseInt(this.completionPercentage) > 25 && !this.videoCompleted25Perc) {
        this.videoCompleted25Perc = true;
        PushDataToAdobeLayer('video_view_25');
      }
      if (parseInt(this.completionPercentage) > 50 && !this.videoCompleted50Perc) {
        this.videoCompleted50Perc = true;
        PushDataToAdobeLayer('video_view_50');
      }
      if (parseInt(this.completionPercentage) > 75 && !this.videoCompleted75Perc) {
        this.videoCompleted75Perc = true;
        PushDataToAdobeLayer('video_view_75');
      }
      if (time > 0.0001 && !this.videoStart) {
        this.videoStart = true;
        PushDataToAdobeLayer('video_start');
      }
    }

    this.progressControl.setProgress(percent);
    var posTime = utils.toHHMMSS(Math.floor(time).toString());
    this.duration.pos.html(posTime);
    setTimeout(function() {
      self.updateTime.call(self); //this is so dumb (global scoped setTimeout)
    }, 500);
  }
};

var YouTubePlayer = Backbone.View.extend({

  initialize: function() {

    this.videoId = this.$el.data('videoId');
    this.videoContainer = this.$('.player')[0];
    this.showControls = (this.$el.data('controls')) ? this.$el.data('controls') : 0;

    if (window.youTubeIframeApiReady) {
      this.createPlayer();
    } else {
      mediator.on('youtubeApiIframe:ready', this.createPlayer, this);
    }

  },

  createPlayer: function() {
    var self = this,
      YT = window.YT;
    this.player = new YT.Player(this.videoContainer, {
      height: '390',
      width: '640',
      videoId: this.videoId,
      playerVars: {
        controls: 1,
        showinfo: 0,
        autohide: 1
      },
      events: {
        onReady: _.bind(self.onPlayerReady, this),
        onStateChange: _.bind(self.onPlayerChange, this)
      }
    });
  },
  onPlayerReady: function() {
    this.ctrlDiv = new ControlDiv(this.player, this.$el);
    this.completionPercentage = 0;
    this.videoCompleted75Perc = false;
    this.videoCompleted50Perc = false;
    this.videoCompleted25Perc = false;
    this.videoCompleted = false;
    this.videoStart = false;
  },
  onPlayerChange: function(state) {
    this.ctrlDiv.playControl.updateIcon(state);
    this.ctrlDiv.updateTime();

    if(!EnableAdobeAnalytics.isEnabled()) {
      if (state.data === YOUTUBE_PLAYER_STATE_UNSTARTED) {
        Analytics.pushToEventFramework({
        event: config.analytics.events.click,
        category: config.analytics.categories.video,
        action: config.analytics.actions.play,
        label: state.target.getVideoUrl()
        });
      }
    }
    if (state.data === 0) {
      mediator.trigger(config.events.youtubePlayer.done);
      if (EnableAdobeAnalytics.isEnabled() && !this.videoCompleted) {
        this.videoCompleted = true;
        PushDataToAdobeLayer('video_completed');
      }
    }
  }
},
{
  create: function($parent) {
    // Buying options views
    $parent.find('.YouTubeWrapper').each(function(n, el) {
      new YouTubePlayer({
        el: el
      });
    });
  }
});

module.exports = YouTubePlayer;



// WEBPACK FOOTER //
// ./assets/js/components/YouTubePlayer.js